<template>
  <div>
    <v-list-item>
      <v-list-item-icon>
        <v-icon :color="isInvitation ? 'secondary' : 'primary'">
          {{ isInvitation ? "mdi-account-clock" : "mdi-account-check" }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title
          v-text="isInvitation ? manager.email : `${manager.firstName} ${manager.lastName}`"
        ></v-list-item-title>
        <v-list-item-subtitle>
          <span v-if="isInvitation">Invitation envoyée</span>
          <span v-else-if="$store.state.loggedUser.email === manager.email">
            Vous êtes gestionnaire de cette cantine
          </span>
          <span v-else>{{ manager.email }}</span>
        </v-list-item-subtitle>
        <!-- Le rôle est porté par le rattachement à *cette* cantine, pas par le profil. -->
        <v-list-item-subtitle v-if="roleLabels.length">
          {{ roleLabels.length > 1 ? "Rôles" : "Rôle" }} : {{ roleLabels.join(", ") }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <AdminRemovalDialog v-if="showDeleteButton" :manager="manager" v-model="dialog" @delete="deleteManager" />
    </v-list-item>
    <v-divider aria-hidden="true" role="presentation" class="my-1"></v-divider>
  </div>
</template>

<script>
import AdminRemovalDialog from "./AdminRemovalDialog"
import Constants from "@/constants"

export default {
  components: { AdminRemovalDialog },
  data() {
    return {
      dialog: false,
    }
  },
  props: {
    manager: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isInvitation() {
      return !this.manager.lastName
    },
    // `jobs` pour un rattachement (plusieurs rôles possibles), `job` pour une invitation.
    // Les gestionnaires n'ont ni l'un ni l'autre : la ligne n'apparaît alors pas.
    roleLabels() {
      const jobs = this.manager.jobs || (this.manager.job ? [this.manager.job] : [])
      const labels = Constants.StaffJobs.reduce(
        (acc, choice) => Object.assign(acc, { [choice.value]: choice.label }),
        {}
      )
      return jobs.map((job) => labels[job] || job)
    },
    showDeleteButton() {
      return this.$store.state.loggedUser.email !== this.manager.email
    },
  },
  methods: {
    deleteManager() {
      this.$emit("delete", this.manager)
      this.dialog = false
    },
  },
}
</script>
